import Keycloak from 'keycloak-js';

const AUTH_URI: string = process.env.VUE_APP_MYSMARTWAY_AUTH_URI ?? '';
const AUTH_CLIENT: string = process.env.VUE_APP_MYSMARTWAY_AUTH_CLIENT ?? '';
const AUTH_REALM: string = process.env.VUE_APP_MYSMARTWAY_AUTH_REALM ?? '';

const initOptions = {
    url: AUTH_URI, realm: AUTH_REALM , clientId: AUTH_CLIENT,
};

const authService = Keycloak(initOptions);

export default authService;
